export const parseImage = (image: string | Blob): string => {
  return typeof image === "string" ? image : URL.createObjectURL(image)
}
